import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const defaultContextValue = {
  navigationConfig: [],
  pushContentUnderTheNavigation: false,
  isTransparentMobileMenu: false,
  displayBookingBtn: true,
  displayLoginButton: true,
  TFunction: () => "default_value",
  allowSkipContent: true,
  languageConfig: {
    currentLanguage: void 0,
    languages: []
  },
  currentURL: "",
  callbacks: {
    onLanguageSelect: (_code) => {
    },
    onLogin: () => {
    },
    onBook: () => {
    }
  },
  components: {
    LogoComponent: () => /* @__PURE__ */ jsx("div", {})
  }
};
const HeaderContext = createContext(defaultContextValue);
const HeaderContextProvider = ({
  children,
  ...props
}) => {
  const config = {
    ...defaultContextValue,
    ...props
  };
  return /* @__PURE__ */ jsx(HeaderContext.Provider, { value: config, children });
};
const useHeaderContext = () => {
  const headerContext = useContext(HeaderContext);
  if (!headerContext) {
    throw new Error("No header context!");
  }
  return headerContext;
};
export {
  HeaderContextProvider,
  useHeaderContext
};
